import cn from "classnames";
import * as React from "react";

type Props = {
  children?: React.ReactNode;
  className?: string;
  cards?: boolean;
  deck?: boolean;
  gutters?: "xs" | "sm" | "md" | "lg";
  alignItems?: string;
  justifyContent?: string;
};

const GridRow: React.FC<Props> = ({
  className,
  children,
  cards,
  deck,
  gutters = "",
  alignItems = "",
  justifyContent = "",
}) => {
  const classes: string = cn(
    `row`,
    {
      row: true,
      "row-cards": cards,
      "row-deck": deck,
      [`gutters-${gutters}`]: gutters,
      [`align-items-${alignItems}`]: alignItems,
      [`justify-content-${justifyContent}`]: justifyContent,
    },
    className
  );
  return <div className={classes}>{children}</div>;
};

export default GridRow;
